import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const AuthErrorRecovery = () => {
  const navigate = useNavigate()
  const { forceLogout, emergencyAuthCleanup } = useAuth()

  const handleRecovery = async () => {
    console.log('[Recovery] User initiated recovery')
    
    try {
      // Force cleanup
      await emergencyAuthCleanup()
      await forceLogout()
      
      // Redirect to home
      navigate('/', { replace: true })
      
      // Force reload to clear any remaining state
      window.location.reload()
    } catch (error) {
      console.error('[Recovery] Recovery failed, forcing reload:', error)
      // Last resort: just reload the page
      window.location.href = '/'
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="text-6xl mb-4">🔧</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Problém s prihlásením
        </h1>
        <p className="text-gray-600 mb-6">
          Aplikácia detekovala neplatnú reláciu. Toto môže nastať keď otvoríte novú kartu s rôznym používateľom alebo keď relácia vypršala.
        </p>
        <p className="text-sm text-gray-500 mb-8">
          Kliknutím na tlačidlo nižšie vyčistíte reláciu a budete presmerovaný na prihlasovaciu stránku.
        </p>
        <button
          onClick={handleRecovery}
          className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition"
        >
          Opraviť a pokračovať
        </button>
        <p className="text-xs text-gray-400 mt-4">
          Toto automaticky vyčistí všetky dáta relácie a znovu vás prihlási.
        </p>
      </div>
    </div>
  )
}

export default AuthErrorRecovery
